enum AppRoutes {
  Home = 'Home',
  Scan = 'Scan',
  Account = 'Account',
  AccountFunding = 'AccountFunding',
  AccountSetupAutoFund = 'AccountSetupAutoFund',
  PantryMarketSearch = 'PantryMarketSearch',
  InsufficientCredit = 'InsufficientCredit',
  ScanMarketCard = 'ScanMarketCard',
  EnterPin = 'EnterPin',
  CashlessDeviceSettings = 'CashlessDeviceSettings',
  PayrollDeduct = 'PayrollDeduct',
  ProductCategorySearch = 'ProductCategorySearch',
  PrivacyPolicy = 'PrivacyPolicy',
  WebContent = 'WebContent',
  RefundSummary = 'RefundSummary',
  EatItOrDeleteItWelcome = 'EatItOrDeleteItWelcome',
  ProductFeedbackInstruction = 'ProductFeedbackInstruction',
  FeedbackLocationScan = 'FeedbackLocationScan',
  ProductFeedback = 'ProductFeedback',
  ProductFeedbackComplete = 'ProductFeedbackComplete',
  Promotions = 'Promotions',
  Passcode = 'Passcode',
  OperatorMachines = 'OperatorMachines',
  Vending = 'Vending',
  PurchaseHistoryDetail = 'PurchaseHistoryDetail',
  ReferralSummary = 'ReferralSummary',
  AccountSetup = 'AccountSetup',
  PurchaseHistory = 'PurchaseHistory',
  CreditCardStripe = 'CreditCardStripe',
  CreditCard = 'CreditCard',
  CreditCardAdd = 'CreditCardAdd',
  ResetPin = 'ResetPin',
  ChangePassword = 'ChangePassword',
  Login = 'Login',
  WelcomeAuth0 = 'WelcomeAuth0',
  Welcome = 'Welcome',
  NeverUsedApp = 'NeverUsedApp',
  LinkExistingAccount = 'LinkExistingAccount',
  Redirect = 'Redirect',
  Receipt = 'Receipt',
  Cards = 'Cards',
  AddEGiftCard = 'AddEGiftCard',
  AddEGiftCardManual = 'AddEGiftCardManual',
  MachineSettings = 'MachineSettings',
  AttachDevice = 'AttachDevice',
  WiFiSettings = 'WiFiSettings',
  DeviceSettings = 'DeviceSettings',
  EditImage = 'EditImage',
  ContactUs = 'ContactUs',
  CreditCardDetail = 'CreditCardDetail',
  MachineRename = 'MachineRename',
  Environment = 'Environment',
  MachineEnvironment = 'MachineEnvironment',
  Main = 'Main',
  MainConsumer = 'MainConsumer',
  MyModal = 'MyModal',
  AutoReloadPanel = 'AutoReloadPanel',
  InventoryPlanogram = 'InventoryPlanogram',
  ProductInventory = 'ProductInventory',
  ProductList = 'ProductList',
  MainProduct = 'MainProduct',
  ProductNutrition = 'ProductNutrition',
  EnteredEmail = 'EnteredEmail',
  KioskCreateAccount = 'KioskCreateAccount',
  KioskCreatePassword = 'KioskCreatePassword',
  ManageAccount = 'ManageAccount',
  VMCDiagnostics = 'VMCDiagnostics',
  CreateMachine = 'CreateMachine',
  CountrySelection = 'CountrySelection',
  ItalyAccountInfo = 'ItalyAccountInfo',
  ChangeEmail = 'ChangeEmail',
  CheckEmail = 'CheckEmail',
  ScanKioskQR = 'ScanKioskQR',
  CreateAccountEnterEmail = 'CreateAccountEnterEmail',
  KioskChangeEmail = 'KioskChangeEmail',
  Rewards = 'Rewards',
  QRCode = 'QRCode',
  Connect = 'Connect',
  App = 'App',
  Machines = 'Machines',
  Operator = 'Operator',
  ExistingAccount = 'ExistingAccount',
  Demographic = 'Demographic',
  Shop = 'Shop',
  MessageDetail = 'MessageDetail',
  Inbox = 'Inbox',
  Loading = 'Loading',
  Funding = 'Funding',
  Settings = 'Settings',
  Help = 'Help',
  DealDetail = 'DealDetail',
  LocationCode = 'LocationCode',
  PickupTime = 'PickupTime',
  Menu = 'Menu',
  ProductDetail = 'ProductDetail',
  ProductUpsell = 'ProductUpsell',
  CoffeeMachine = 'CoffeeMachine',
  PickupLocation = 'PickupLocation',
  Disclaimer = 'Disclaimer',
  RecentOrders = 'RecentOrders',
  Feedback = 'Feedback',
  BunnDispense = 'BunnDispense',
  EditMarketCard = 'EditMarketCard',
  PayrollDeductAgreement = 'PayrollDeductAgreement',
  VendorsExchangeVending = 'VendorsExchangeVending',
  Referral = 'Referral',
  ReferralLanding = 'ReferralLanding',
  AccountReady = 'AccountReady',
  ShareReceipt = 'ShareReceipt',
  GiftFeed = 'GiftFeed',
  SnackBlockedUsers = 'SnackBlockedUsers',
  SendSnack = 'SendSnack',
  ChooseContact = 'ChooseContact',
  SnackDetail = 'SnackDetail',
  Balances = 'Balances',
  DeleteAccount = 'DeleteAccount',
  OrderNote = 'OrderNote',
  Empty = '',
  DetectedBeacon = 'DetectedBeacon',
  AppTourWelcome = 'AppTourWelcome',
  AppTour = 'AppTour',
  AppProductTour = 'AppProductTour',
  ViewNutrition = 'ViewNutrition',
}

export default AppRoutes;
export type RootRoutes =
  | 'Login'
  | 'Passcode'
  | 'App'
  | 'Operator'
  | 'Loading'
  | 'AppProductTour';
